// 未保存変更ガード - 未保存変更がある場合にページ離脱を確認

import { inject } from '@angular/core';

import { UnsavedChangesConfirmService } from './unsaved-changes-confirm.service';

import type { HasUnsavedChanges } from './unsaved-changes.models';
import type { CanDeactivateFn } from '@angular/router';

/**
 * 未保存変更チェックガード
 * 未保存変更がある場合にMaterial Dialogで確認ダイアログを表示し、
 * ユーザーが確認した場合のみページ離脱を許可する
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component,
) => {
  const confirmService = inject(UnsavedChangesConfirmService);

  // 未保存変更がない場合はそのまま遷移許可
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  return confirmService.confirm();
};
